(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hiknight-universal-mega-menu"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT = '[data-hiknight-universal-mega]';
  const desktopMQ = window.matchMedia('(min-width: 1024px)');
  const finePointerMQ = window.matchMedia('(hover:hover) and (pointer:fine)');

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function visible(el) {
    if (!(el instanceof HTMLElement)) return false;
    const r = el.getBoundingClientRect();
    const s = getComputedStyle(el);
    return r.width > 1 && r.height > 1 && s.visibility !== 'hidden' && s.display !== 'none';
  }

  function findTrigger(root) {
    const label = normalize(root.dataset.triggerLabel);
    if (!label) return null;
    const header = root.closest('header') || document.querySelector('header') || document;
    const candidates = [...header.querySelectorAll('a,button,summary,[role="button"]')]
      .filter((el) => !root.contains(el) && visible(el));
    const exact = candidates.find((el) => normalize(el.textContent) === label);
    if (exact) return exact;
    const near = candidates.find((el) => {
      const text = normalize(el.textContent);
      return text.startsWith(label) || text.endsWith(label);
    });
    if (near) return near;

    return [...document.querySelectorAll('header a,header button,header summary,header [role="button"]')]
      .find((el) => !root.contains(el) && visible(el) && normalize(el.textContent) === label) || null;
  }

  function setup(root) {
    if (!(root instanceof HTMLElement) || root.dataset.hiknightUniversalReady === 'true') return;
    root.dataset.hiknightUniversalReady = 'true';

    const shell = root.querySelector('.hiknight-universal-mega__shell');
    const backdrop = root.querySelector('[data-hiknight-mega-backdrop]');
    const tabs = [...root.querySelectorAll('[data-hiknight-mega-tab]')];
    const panels = [...root.querySelectorAll('[data-hiknight-mega-panel]')];
    const openMode = root.dataset.openMode || 'hover';
    const closeDelay = Math.max(80, Number(root.dataset.closeDelay || 180));
    const preventNavigation = root.dataset.preventTriggerNavigation === 'true';
    let trigger = null;
    let closeTimer = 0;

    function activate(index) {
      tabs.forEach((tab, i) => tab.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }

    function setTop() {
      if (!trigger) return;
      const rect = trigger.getBoundingClientRect();
      const top = Math.max(0, Math.round(rect.bottom));
      root.style.setProperty('--hiknight-mega-top', `${top}px`);
    }

    function clearClose() {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = 0;
    }

    function open() {
      if (!desktopMQ.matches) return;
      clearClose();
      if (!trigger || !document.contains(trigger)) trigger = findTrigger(root);
      if (!trigger) return;
      setTop();
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('hiknight-universal-mega-open');
    }

    function close() {
      clearClose();
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      trigger?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('hiknight-universal-mega-open');
    }

    function scheduleClose() {
      clearClose();
      closeTimer = window.setTimeout(() => {
        if (trigger?.matches(':hover') || shell?.matches(':hover')) return;
        close();
      }, closeDelay);
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('pointerenter', () => { if (finePointerMQ.matches) activate(index); });
      tab.addEventListener('focus', () => activate(index));
      tab.addEventListener('click', () => activate(index));
    });

    function bindTrigger() {
      trigger = findTrigger(root);
      if (!trigger || trigger.dataset.hiknightUniversalTrigger === root.id) return;
      trigger.dataset.hiknightUniversalTrigger = root.id;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');

      const nativeDetails = trigger.closest('details[is="details-mega"], details[is="details-dropdown"]');

      /*
        This standalone HIKNIGHT menu owns the desktop Electric Bike dropdown.
        Concept's native details-mega must not open at the same time, otherwise
        the small white fallback dropdown can occasionally appear.
      */
      if (nativeDetails) {
        nativeDetails.setAttribute('trigger', 'hiknight-external');

        const shutNative = () => {
          try {
            if ('open' in nativeDetails && nativeDetails.open === true) {
              nativeDetails.open = false;
            }
          } catch (error) {}
          nativeDetails.removeAttribute('open');
          nativeDetails.firstElementChild?.removeAttribute('open');
          nativeDetails.lastElementChild?.removeAttribute('open');
        };

        shutNative();

        trigger.addEventListener('click', (event) => {
          if (!desktopMQ.matches) return;
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }

          shutNative();
          if (root.classList.contains('is-open')) close(); else open();
        }, true);

        nativeDetails.addEventListener('mouseenter', shutNative, true);
        nativeDetails.addEventListener('mouseleave', shutNative, true);
      } else {
        trigger.addEventListener('click', (event) => {
          if (!desktopMQ.matches) return;
          if (preventNavigation || openMode === 'click') event.preventDefault();
          if (root.classList.contains('is-open')) close(); else open();
        });
      }

      if (openMode === 'hover') {
        trigger.addEventListener('pointerenter', () => { if (finePointerMQ.matches) open(); });
        trigger.addEventListener('pointerleave', scheduleClose);
        trigger.addEventListener('focus', open);
      }
    }

    shell?.addEventListener('pointerenter', clearClose);
    shell?.addEventListener('pointerleave', scheduleClose);
    backdrop?.addEventListener('click', close);

    document.addEventListener('click', (event) => {
      if (!root.classList.contains('is-open')) return;
      if (root.contains(event.target) || trigger?.contains(event.target)) return;
      close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        close();
        trigger?.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (!desktopMQ.matches) close();
      else if (root.classList.contains('is-open')) setTop();
    }, { passive: true });

    window.addEventListener('scroll', () => {
      if (root.classList.contains('is-open')) setTop();
    }, { passive: true });

    bindTrigger();
    window.setTimeout(bindTrigger, 500);
    window.setTimeout(bindTrigger, 1500);
  }

  const init = (scope = document) => scope.querySelectorAll?.(ROOT).forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
